import { Button } from '@/components/ui/atoms/button'
import { cn } from '@/lib/client'
import { ArrowUpRight } from 'lucide-react'

export default function KnowUsBanner({
  className,
  handleClick,
}: {
  className?: string
  handleClick: (ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}) {
  return (
    <div className={cn('my-8', className)}>
      <div className="relative isolate overflow-hidden bg-zinc-900 py-12 px-8 rounded-xl">
        <div className="flex flex-col text-center sm:flex-row lg:text-left lg:items-center">
          <div className="basis-1/2">
            <img
              loading="lazy"
              src={'/images/founders.png'}
              className="w-full h-full rounded-tl-xl rounded-br-xl"
              alt={'Fundadores - Direção Concursos'}
              width={300}
              height={200}
            />
          </div>
          <div className="basis-1/2 space-y-4 mt-6 lg:mt-0 sm:ml-3 lg:ml-12 lg:items-center">
            <h3 className="text-2xl font-bold tracking-tight text-white sm:text-3xl">
              Conheça o Direção Concursos
            </h3>
            <p className="mt-4 text-md leading-6 text-zinc-300">
              O Direção Concursos é uma escola de cursos online para concursos
              públicos, que desde 2018 vem ajudando as pessoas a alcançarem seus
              sonhos.
            </p>
            <p className="mt-4 text-md leading-6 text-zinc-300">
              Já aprovamos milhares de concurseiros como você, além dos
              primeiros lugares que muitos destes conquistaram. Temos os
              melhores materiais e assinaturas do mercado para você ser
              aprovado.
            </p>
            <Button
              variant={'default'}
              className="w-full lg:w-[180px]"
              onClick={handleClick}
            >
              Confira nossos cursos
              <ArrowUpRight className="ml-1 h-4 w-4" />
            </Button>
          </div>
        </div>
        <div
          className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-35rem)]"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#80d7ff] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>
      </div>
    </div>
  )
}
